import { render, staticRenderFns } from "./IndexList063.vue?vue&type=template&id=03d46566&scoped=true&"
import script from "./IndexList063.vue?vue&type=script&lang=js&"
export * from "./IndexList063.vue?vue&type=script&lang=js&"
import style0 from "./IndexList063.vue?vue&type=style&index=0&id=03d46566&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d46566",
  null
  
)

export default component.exports